export const GENERAL = {
  AppName: 'Howden Teladoc',
  UsrStorageKey: 'usr'
};